module.exports = __webpack_public_path__ + "static/media/radnet-logo.6c934a22.jpeg";